import { request } from './http-client';
import { IComputePrice } from './types/fares';

export interface IComputePayload {
  branch_id: string | undefined;
  crm_type?: string | undefined;
  delivery_zone_id: string;
  fare_id?: string;
  from_door_to_door?: boolean;
  is_immediately?: boolean;
  is_yandex_delivery?: boolean;
  is_home_page_delivery?: boolean
  lat: number;
  long: number;
  order_details?: {
    accommodation?: string;
    apartment?: string;
    branch_id: string;
    building?: string;
    client_name: string;
    client_phone_number: string;
    co_delivery_price?: string;
    delivery_price?: string;
    description: string;
    external_delivery_id?: string;
    extra_phone_number?: string;
    external_order_id?: number;
    floor?: string;
    future_time?: string;
    id?: string;
    is_courier_call?: boolean;
    is_preorder?: boolean;
    order_amount?: number;
    order_type_id?: string;
    paid?: boolean;
    payment_type_id: string;
    products: {
      id?: string;
      name: string;
      price: number;
      product_id: string;
      quantity: number;
    }[];
    source_id: string;
    to_address: string;
    to_address_description?: string;
    to_location?: {
      address?: string;
      lat: number;
      long: number;
    };
    vendor_comment?: string;
    yandex_claim_id?: string;
  };
  order_price: number;
  source?: string;
  with_thermobag?: boolean;
  yandex_class?: string;
  yandex_token?: string;
}

const getComputedPrice = (data: any, shipperId?: string) =>
  request.patch<IComputePrice>('/v1/fares/compute-price', data, {
    headers: shipperId ? { Shipper: shipperId } : undefined,
  });

export default getComputedPrice;
